var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BDA49C16-5C34-4554-9878-9FCEE64AD4AD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Graph-Style/Table",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,5.5 C13,5.775 12.775,6 12.5,6 L10.5,6 C10.225,6 10,5.775 10,5.5 L10,4.5 C10,4.225 10.225,4 10.5,4 L12.5,4 C12.775,4 13,4.225 13,4.5 L13,5.5 Z M13,8.5 C13,8.775 12.775,9 12.5,9 L10.5,9 C10.225,9 10,8.775 10,8.5 L10,7.5 C10,7.225 10.225,7 10.5,7 L12.5,7 C12.775,7 13,7.225 13,7.5 L13,8.5 Z M13,11.5 C13,11.775 12.775,12 12.5,12 L10.5,12 C10.225,12 10,11.775 10,11.5 L10,10.5 C10,10.225 10.225,10 10.5,10 L12.5,10 C12.775,10 13,10.225 13,10.5 L13,11.5 Z M8.5,5.5 C8.5,5.775 8.275,6 8,6 L6,6 C5.725,6 5.5,5.775 5.5,5.5 L5.5,4.5 C5.5,4.225 5.725,4 6,4 L8,4 C8.275,4 8.5,4.225 8.5,4.5 L8.5,5.5 Z M8.5,8.5 C8.5,8.775 8.275,9 8,9 L6,9 C5.725,9 5.5,8.775 5.5,8.5 L5.5,7.5 C5.5,7.225 5.725,7 6,7 L8,7 C8.275,7 8.5,7.225 8.5,7.5 L8.5,8.5 Z M8.5,11.5 C8.5,11.775 8.275,12 8,12 L6,12 C5.725,12 5.5,11.775 5.5,11.5 L5.5,10.5 C5.5,10.225 5.725,10 6,10 L8,10 C8.275,10 8.5,10.225 8.5,10.5 L8.5,11.5 Z M4,5.5 C4,5.775 3.775,6 3.5,6 L1.5,6 C1.225,6 1,5.775 1,5.5 L1,4.5 C1,4.225 1.225,4 1.5,4 L3.5,4 C3.775,4 4,4.225 4,4.5 L4,5.5 Z M4,8.5 C4,8.775 3.775,9 3.5,9 L1.5,9 C1.225,9 1,8.775 1,8.5 L1,7.5 C1,7.225 1.225,7 1.5,7 L3.5,7 C3.775,7 4,7.225 4,7.5 L4,8.5 Z M4,11.5 C4,11.775 3.775,12 3.5,12 L1.5,12 C1.225,12 1,11.775 1,11.5 L1,10.5 C1,10.225 1.225,10 1.5,10 L3.5,10 C3.775,10 4,10.225 4,10.5 L4,11.5 Z M13,2 L1,2 C0.447,2 0,2.448 0,3 L0,12 C0,12.552 0.447,13 1,13 L13,13 C13.553,13 14,12.552 14,12 L14,3 C14,2.448 13.553,2 13,2 L13,2 Z",
    id: "Page-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.ed6b2ffed2dccdb44744b08f1d43f637.svg";
export { ForwardRef as ReactComponent };